import { mapActions } from 'vuex'

export default {
  ...mapActions(['setupJWT', 'updateUserData', 'setupUser', 'updateSettings']),
  doLogin () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }

    const credentials = {...this.credentials}
    if (this.credentials.type === 'professional') {
      delete credentials.country_register
    } else {
      delete credentials.document
      delete credentials.state
    }

    const setUserData = (data) => {
      Promise.all([
        this.updateUserData(data.user),
        this.setupJWT(data.token)
      ])
        .then(() => {
          this.setupUser()
            .then(() => {
              return this.$router.push({name: 'professional.dashboard.professional.index'})
            })
        })
    }

    this.$resource.post('', credentials)
      .then(({data}) => {
        setUserData(data)
      })
      .catch(({data, meta}) => {
        this.loginFail = true
      })
  },
  focusFirstStatus (component = this) {
    if (component.status) {
      component.$el.focus()
      return true
    }

    let focused = false

    component.$children.some((childComponent) => {
      focused = this.focusFirstStatus(childComponent)
      return focused
    })

    return focused
  },
  goToLoadingPageProfessional () {
    location.href = this.URL_LOADING_PAGE_PROFESSIONAL
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/professional/resources/methods.js